import MiscCards from "./MiscCards";

export default MiscCards;